import { Component, inject, OnInit } from '@angular/core';
import {
  GridColumnComponent,
  GridContainerComponent,
  GridRowComponent,
  IconComponent,
  RegisterAnotherApplianceComponent,
  RegisteredApplianceSummaryComponent,
} from '@components';
import { GADataService } from '@data-access';
import { provideTranslationDictionaryMapping, TranslatePipe } from '@i18n';
import { TrackingService } from '@tracking';
import { ProtectedApplianceSummaryComponent } from '../../components/protected-appliance-summary/protected-appliance-summary.component';
import { translation } from '../../i18n/translation.constant';

@Component({
  selector: 'app-order-confirmation',
  imports: [
    GridColumnComponent,
    GridContainerComponent,
    GridRowComponent,
    IconComponent,
    ProtectedApplianceSummaryComponent,
    RegisterAnotherApplianceComponent,
    RegisteredApplianceSummaryComponent,
    TranslatePipe,
  ],
  templateUrl: './order-confirmation.component.html',
  styleUrl: './order-confirmation.component.scss',
  providers: [provideTranslationDictionaryMapping(translation)],
})
export class OrderConfirmationComponent implements OnInit {
  private readonly gaDataService = inject(GADataService);
  private readonly trackingService = inject(TrackingService);

  ngOnInit(): void {
    this.trackingService.trackEvent(this.gaDataService.eventPurchase());
  }
}
